import { GridCellProps } from "@progress/kendo-react-grid";
import React from "react";
import { DEFAULT_DATETIME24H_FORMAT, ExpeditedPriority } from "Utilities";
import { DateCellContent } from "../InputCells";
import Acute from "Assets/Icons/acute.svg";
import { Tooltip } from '@mui/material';

export const dueDateTimeCell: React.FC<GridCellProps> = (
  props: GridCellProps
) => {
  return (
    <td>
      <div className='d-flex'>
        <DateCellContent {...props} dateFormat={DEFAULT_DATETIME24H_FORMAT} />
        {props?.dataItem?.tatPriority && props?.dataItem?.tatPriority.displayName === ExpeditedPriority && (
          <Tooltip title="Expedited" placement="bottom">
            <img
              src={Acute}
              alt="Expedited"
              style={{ width: '16.67px', height: '16.67px', marginLeft: '8px' }}
            />
          </Tooltip>
        )}
      </div>
    </td>
  );
};